class Faq {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.bindButtons(this.el);
        } catch (error) {
            console.log(error);
        }
    }

    bindButtons(buttons) {
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener("click", function () {
                if (this.classList.contains("active")) {
                    // If the clicked element is already active, deactivate it
                    this.classList.remove("active");
                    var answer = this.nextElementSibling;
                    answer.style.maxHeight = null;
                } else {
                    // Deactivate all elements
                    for (let j = 0; j < buttons.length; j++) {
                        buttons[j].classList.remove("active");
                        var answer = buttons[j].nextElementSibling;
                        answer.style.maxHeight = null;
                    }

                    // Activate the clicked element
                    this.classList.add("active");
                    var answer = this.nextElementSibling;
                    answer.style.maxHeight = answer.scrollHeight + "px";
                }
            });
        }
    }
}

export default Faq;
